module.exports = __webpack_public_path__ + "img/any-mbg1.c16dea44.png";